import * as React from 'react';

import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib/utils';

const badgeVariants = cva(
  'vai-inline-flex vai-items-center vai-rounded vai-border vai-px-1 vai-py-0.5 vai-text-xs vai-font-semibold vai-transition-colors focus:vai-outline-none focus:vai-ring-2 focus:vai-ring-ring focus:vai-ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'vai-border-transparent vai-bg-primary vai-text-primary-foreground hover:vai-bg-primary/80',
        secondary:
          'vai-border-transparent vai-bg-secondary vai-text-secondary-foreground hover:vai-bg-secondary/80',
        destructive:
          'vai-border-transparent vai-bg-destructive vai-text-destructive-foreground hover:vai-bg-destructive/80',
        outline: 'vai-text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
